import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=1c6470ea&scoped=true&"
import script from "./ImgDragSort.vue?vue&type=script&lang=js&"
export * from "./ImgDragSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6470ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6470ea')) {
      api.createRecord('1c6470ea', component.options)
    } else {
      api.reload('1c6470ea', component.options)
    }
    module.hot.accept("./ImgDragSort.vue?vue&type=template&id=1c6470ea&scoped=true&", function () {
      api.rerender('1c6470ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/ImgDragSort.vue"
export default component.exports